import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SiteStructureType } from '../../../types/siteStructureType';
import { actions as siteStructureActions } from '../redux/modules/sitestructure';
import useSelector from '../redux/typedHooks';
import { RootState } from '../redux/types';
import { useAuth0Token } from './useAuth0Token';

function selectCategory(slug: SiteStructureType['slug'], app: string) {
  return (state: RootState) => state.sitestructure.categoryApps[`${slug}/${app}`];
}

export function useCategoryApp(slug: SiteStructureType['slug'], app: string) {
  const select = selectCategory(slug, app);
  const categoryApp = useSelector(select);
  const { isUpdating, isEnriched, isLoggedIn } = categoryApp?.meta || {};
  const { simpleToken } = useAuth0Token();

  const dispatch = useDispatch();

  useEffect(() => {
    if (!categoryApp?.error && !isUpdating && (!isEnriched || (simpleToken && !isLoggedIn))) {
      dispatch(
        siteStructureActions.getCategoryApp.request(
          {
            slug,
            app,
          },
          { token: simpleToken },
        ),
      );
    }
  }, [dispatch, slug, app, categoryApp?.error, isEnriched, isUpdating, simpleToken, isLoggedIn]);

  return categoryApp;
}
